<template>
  <SidebarComponent />
  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">
        <div class="titolo-card">
          <h1>Benvenuto nella tua dashboard</h1>
        </div>

        <DashboardBundleLinks />

<!-- Quick actions (pastello) -->
<div class="quick-grid">
  <button class="quick-card q-blue" @click="goToPromemoriaPubblico">
    <span class="material-icons quick-icon">alarm</span>
    <div class="quick-text">
      <div class="quick-title">Promemoria Pubblici</div>
      <div class="quick-sub">Vai alla lista</div>
    </div>
  </button>

    <button class="quick-card q-blue" @click="goToContatti">
    <span class="material-icons quick-icon">groups_3</span>
    <div class="quick-text">
      <div class="quick-title">Contatti Nuovi</div>
      <div class="quick-sub">Vai alla lista</div>
    </div>
  </button>


  <button class="quick-card q-orange" @click="goToOrdini">
    <span class="material-icons quick-icon">shopping_bag</span>
    <div class="quick-text">
      <div class="quick-title">Ordini</div>
      <div class="quick-sub">Gestisci ordini</div>
    </div>
  </button>


</div>



<!-- Quick actions (pastello) -->
<div class="quick-grid">



  
    <button class="quick-card q-green" @click="goToQuestionari">
    <span class="material-icons quick-icon">assignment</span>
    <div class="quick-text">
      <div class="quick-title">Questionari da lavorare</div>
      <div class="quick-sub">Compilazioni e stati</div>
    </div>
  </button>


  <button class="quick-card q-orange" @click="goToQuestionariScaduti">
    <span class="material-icons quick-icon">assignment</span>
    <div class="quick-text">
      <div class="quick-title">Questionari scaduti</div>
      <div class="quick-sub">Compilazioni e stati</div>
    </div>
  </button>

  <button class="quick-card q-green" @click="goToQuestionariManuali">
    <span class="material-icons quick-icon">assignment_ind</span>
    <div class="quick-text">
      <div class="quick-title">Questionari manuali</div>
      <div class="quick-sub">Senza percorso</div>
    </div>
  </button>

    <button class="quick-card q-orange" @click="goToConsulenze">
    <span class="material-icons quick-icon">assignment</span>
    <div class="quick-text">
      <div class="quick-title">Consulenze</div>
      <div class="quick-sub">Tecniche e Nustrizionali</div>
    </div>
  </button>

      <button class="quick-card q-purple" @click="goToOrdersAccounting">
    <span class="material-icons quick-icon">account_balance_wallet</span>
    <div class="quick-text">
      <div class="quick-title">
        Contabilità
        <span class="quick-badge">NEW</span>
      </div>
      <div class="quick-sub">Report finanziario</div>
    </div>
  </button>

  
  <button class="quick-card q-purple" @click="goToCalendari">
    <span class="material-icons quick-icon">event</span>
    <div class="quick-text">
      <div class="quick-title">
        Calendari eventi
        <span class="quick-badge">NEW</span>
      </div>
      <div class="quick-sub">Tecnico · Nutrizione · Commerciale</div>
    </div>
  </button>

  <button class="quick-card q-blue" @click="goToPercorsiNonIniziati">
    <span class="material-icons quick-icon">pending_actions</span>
    <div class="quick-text">
      <div class="quick-title">Percorsi mai iniziati</div>
      <div class="quick-sub">Vai alla lista</div>
    </div>
  </button>

  <button class="quick-card q-blue" @click="goToUsersExpiringList">
    <span class="material-icons quick-icon">hourglass_empty</span>
    <div class="quick-text">
      <div class="quick-title">Utenti in scadenza</div>
      <div class="quick-sub">Vai alla lista</div>
    </div>
  </button>

  <button class="quick-card q-blue" @click="goToPublicBookings">
    <span class="material-icons quick-icon">event_available</span>
    <div class="quick-text">
      <div class="quick-title">
        Prenotazioni Coaching Day
        <span class="quick-badge">NEW</span>
      </div>
      <div class="quick-sub">Vai alla lista</div>
    </div>
  </button>
</div>

<!-- Notifiche (stile dedicato) -->
<div class="notify-grid dashboard-notifications-mobile">
  <button class="notify-card" @click="goToNotifiche10Giorni">
    <span class="material-icons notify-icon">notifications_active</span>
    <div class="notify-text">
      <div class="notify-title">Notifiche 10 giorni</div>
      <div class="notify-sub">Vai alla lista</div>
    </div>
  </button>

  <button class="notify-card" @click="goToNotifiche24Giorni">
    <span class="material-icons notify-icon">notifications</span>
    <div class="notify-text">
      <div class="notify-title">Notifiche 24 giorni</div>
      <div class="notify-sub">Vai alla lista</div>
    </div>
  </button>

  <button class="notify-card" @click="goToNotifiche40Giorni">
    <span class="material-icons notify-icon">notification_important</span>
    <div class="notify-text">
      <div class="notify-title">Notifiche 40 giorni</div>
      <div class="notify-sub">Vai alla lista</div>
    </div>
  </button>

  <button class="notify-card" @click="goToProgrammiDaOscurare">
    <span class="material-icons notify-icon">visibility_off</span>
    <div class="notify-text">
      <div class="notify-title">Programmi da oscurare</div>
      <div class="notify-sub">Vai alla lista</div>
    </div>
  </button>
</div>


        <!--
        <div class="card-image">
          <img src="https://www.metodofusco.it/media/image_desktop_studi.jpg" alt="Descrizione dell'immagine" />
        </div>
-->
      

        <div class="promemoria-container promemoria-block promemoria-block--personal">
          <h2 class="promemoria-block__title">
            <span class="promemoria-block__dot"></span>
            I tuoi Promemoria
          </h2>

          <div class="filters my-reminders-filters">
            <label class="my-reminders-filter-field">
              <span>Da</span>
              <input type="date" v-model="filterFrom" />
            </label>
            <label class="my-reminders-filter-field">
              <span>A</span>
              <input type="date" v-model="filterTo" />
            </label>

            <div class="my-reminders-filter-actions" role="group" aria-label="Azioni filtri promemoria">
              <button type="button" @click="applyFilters" class="create-user-button staff-button-neutral" title="Ricerca" aria-label="Cerca promemoria">
                <span class="material-icons" aria-hidden="true">search</span>
              </button>
              <button type="button" @click="clearDateFilters" class="create-user-button_white" title="Reset" aria-label="Azzera filtri promemoria">
                <span class="material-icons" aria-hidden="true">cached</span>
              </button>
              <button type="button" @click="openAddReminderModal" class="create-user-button staff-button-positive" title="Aggiungi Promemoria" aria-label="Aggiungi promemoria">
                <span class="material-icons" aria-hidden="true">alarm_add</span>
              </button>
              <button type="button" @click="toggleShowHidden" class="create-user-button_white" :title="showHidden ? 'Nascondi Nascosti' : 'Visualizza Nascosti'" :aria-label="showHidden ? 'Nascondi promemoria nascosti' : 'Visualizza promemoria nascosti'">
                <span class="material-icons" aria-hidden="true">{{ showHidden ? 'visibility_off' : 'visibility' }}</span>
              </button>
            </div>

            <label class="my-reminders-filter-field my-reminders-status-field">
              <span>Stato</span>
              <select v-model="filterFatto">
                <option value="da fare">Da fare</option>
                <option value="si">Fatto</option>
                <option value="">Tutti</option>
              </select>
            </label>
          </div>

          <table v-if="filteredReminders.length" class="promemoria-table my-reminders-table">
            <thead>
              <tr>
                <th>Azioni</th>
                <th>Data</th>
                <th>Orario</th>
                <th>Utente</th>
                <th>Tipo</th>
                <th>Urgenza</th>
                <th>Note</th>
                <th>Stato</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="m in filteredReminders" :key="m.id">
                <td class="my-reminders-actions-cell" data-label="Azioni">
                  <div class="promemoria-actions">
                    <button
                      type="button"
                      class="promemoria-actions__btn"
                      :disabled="!m.uid"
                      @click="viewUserProfileInNewTab(m.uid)"
                      :title="m.uid ? 'Apri profilo in una nuova scheda' : 'Profilo utente non disponibile'"
                      :aria-label="m.uid ? 'Apri profilo in una nuova scheda' : 'Profilo utente non disponibile'"
                    >
                      <span class="material-icons" aria-hidden="true">account_circle</span>
                    </button>
                    <button
                      type="button"
                      class="promemoria-actions__btn promemoria-actions__btn--danger"
                      @click="deleteReminder(m)"
                      title="Cancella"
                    >
                      <span class="material-icons">delete</span>
                    </button>
                    <button
                      type="button"
                      class="promemoria-actions__btn"
                      @click="toggleReminderVisibility(m)"
                      :title="m.visibilita ? 'Nascondi' : 'Mostra'"
                    >
                      <span class="material-icons">{{ m.visibilita ? 'visibility_off' : 'visibility' }}</span>
                    </button>
                  </div>
                </td>
                <td class="my-reminders-date-cell" data-label="Data">
  <input type="date" :value="getDateString(m.data)" @blur="updateReminderDate(m, $event.target.value, null)" />
</td>
<td class="my-reminders-time-cell" data-label="Orario">
  <input type="time" :value="getTimeString(m.data)" @blur="updateReminderDate(m, null, $event.target.value)" />
</td>

                <td class="promemoria-email-cell my-reminders-user-cell" data-label="Utente">
                  <span class="promemoria-email">{{ m.userEmail || 'N/A' }}</span>
                </td>
                <td class="my-reminders-type-cell" data-label="Tipo">
                  <select v-model="m.tipo" @change="updateReminderField(m, 'tipo')">
          <option value="telefonata">Chiamata</option>
          <option value="prima telefonata">Prima chiamata</option>
          <option value="whatsapp">Whatsapp</option>
          <option value="email">E-mail</option>
          <option value="live">Dal vivo</option>
          <option value="messaggio">Messaggio</option>
          <option value="check confronto">Check di confronto</option>
          <option value="check lavorare">Check lavorare</option>
          <option value="ricontatto intermedio">Ricontatto intermedio</option>
          <option value="ricontatto finale">Ricontatto finale</option>
          <option value="recupero clienti fermi">Recupero clienti fermi</option>
          <option value="altro">Altro</option>
                  </select>
                </td>
                <td class="my-reminders-urgency-cell" data-label="Urgenza">
                  <select v-model="m.urgenza" @change="updateReminderField(m, 'urgenza')">
                    <option value="bassa">Bassa</option>
                    <option value="media">Media</option>
                    <option value="alta">Alta</option>
                  </select>
                </td>
                <td class="my-reminders-note-cell" data-label="Note">
                  <div class="reminder-note-editor">
                    <input type="text" v-model="m.note" @blur="updateReminderField(m, 'note')" placeholder="Aggiungi nota" class="note-textarea" />
                    <button
                      type="button"
                      class="reminder-note-open"
                      title="Leggi e modifica nota"
                      aria-label="Leggi e modifica nota"
                      @click="openReminderNoteModal(m)"
                    >
                      <span class="material-icons" aria-hidden="true">sticky_note_2</span>
                    </button>
                  </div>
                </td>
                <td class="my-reminders-status-cell" data-label="Stato">
                  <select v-model="m.fatto" @change="updateReminderField(m, 'fatto')">
                    <option value="si">Fatto</option>
                    <option value="da fare">Da fare</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>

          <p v-else>Nessun promemoria nell’intervallo selezionato.</p>
        </div>



        <div class="contact-reminders-card promemoria-block">
          <div class="contact-reminders-card__header">
            <h2 class="promemoria-block__title">
              <span class="promemoria-block__dot"></span>
              Promemoria Contatti Nuovi
            </h2>
            <button
              type="button"
              class="contact-reminders-card__toggle"
              @click="showCompletedContactReminders = !showCompletedContactReminders"
            >
              <span class="material-icons" aria-hidden="true">
                {{ showCompletedContactReminders ? 'visibility' : 'task_alt' }}
              </span>
              {{ showCompletedContactReminders ? 'Mostra da fare' : 'Mostra completati' }}
            </button>
          </div>

          <div class="contact-reminders-search">
            <label class="contact-reminders-search__field">
              <span>Nome e cognome</span>
              <input
                v-model.trim="contactReminderNameSearch"
                type="search"
                autocomplete="off"
              />
            </label>
            <label class="contact-reminders-search__field">
              <span>Telefono</span>
              <input
                v-model.trim="contactReminderPhoneSearch"
                type="search"
                inputmode="tel"
                autocomplete="off"
              />
            </label>
            <button
              type="button"
              class="contact-reminders-search__reset"
              :disabled="!contactReminderNameSearch && !contactReminderPhoneSearch"
              title="Reset ricerca"
              @click="clearContactReminderSearch"
            >
              <span class="material-icons" aria-hidden="true">cached</span>
            </button>
          </div>

          <div v-if="contactRemindersLoading" class="contact-reminders-empty">Caricamento promemoria…</div>
          <table v-else-if="visibleContactReminders.length" class="promemoria-table contact-reminders-table">
            <thead>
              <tr>
                <th class="contact-reminders-actions-cell">Azioni</th>
                <th class="contact-reminders-date-cell">Data</th>
                <th class="contact-reminders-time-cell">Orario</th>
                <th class="contact-reminders-contact-cell">Contatto</th>
                <th class="contact-reminders-note-cell">Nota</th>
                <th class="contact-reminders-consultant-cell">Consulente</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="rem in visibleContactReminders"
                :key="rem.id"
                :class="{
                  'contact-reminder--done': rem.done,
                  'contact-reminder--editing': isContactReminderEditing(rem)
                }"
              >
                <td class="contact-reminders-actions-cell">
                  <div class="promemoria-actions">
                    <template v-if="isContactReminderEditing(rem)">
                      <button
                        type="button"
                        class="promemoria-actions__btn promemoria-actions__btn--success"
                        title="Salva"
                        @click="saveContactReminderEdit(rem)"
                      >
                        <span class="material-icons" aria-hidden="true">save</span>
                      </button>
                      <button
                        type="button"
                        class="promemoria-actions__btn"
                        title="Annulla"
                        @click="cancelContactReminderEdit"
                      >
                        <span class="material-icons" aria-hidden="true">close</span>
                      </button>
                    </template>
                    <template v-else>
                      <button
                        type="button"
                        class="promemoria-actions__btn"
                        :disabled="!canOpenContactReminderProfile(rem) || isContactReminderProfileLoading(rem)"
                        :title="canOpenContactReminderProfile(rem) ? 'Vai al profilo' : 'Profilo utente non trovato'"
                        @click="openContactReminderUserProfile(rem)"
                      >
                        <span class="material-icons">{{ isContactReminderProfileLoading(rem) ? 'hourglass_empty' : 'account_circle' }}</span>
                      </button>
                      <button
                        type="button"
                        class="promemoria-actions__btn"
                        title="Modifica"
                        @click="startContactReminderEdit(rem)"
                      >
                        <span class="material-icons" aria-hidden="true">edit</span>
                      </button>
                      <button
                        type="button"
                        class="promemoria-actions__btn promemoria-actions__btn--success"
                        :title="rem.done ? 'Segna da fare' : 'Segna fatto'"
                        @click="toggleContactReminderDone(rem, !rem.done)"
                      >
                        <span class="material-icons" aria-hidden="true">{{ rem.done ? 'undo' : 'check_circle' }}</span>
                      </button>
                      <button
                        type="button"
                        class="promemoria-actions__btn promemoria-actions__btn--danger"
                        title="Cancella"
                        @click="deleteContactReminder(rem)"
                      >
                        <span class="material-icons" aria-hidden="true">delete</span>
                      </button>
                    </template>
                  </div>
                </td>
                <td class="contact-reminders-date-cell">
                  <input
                    v-if="isContactReminderEditing(rem)"
                    type="date"
                    v-model="contactReminderDraft.dueDate"
                  />
                  <span v-else>{{ formatContactReminderDate(rem) || '—' }}</span>
                </td>
                <td class="contact-reminders-time-cell">
                  <input
                    v-if="isContactReminderEditing(rem)"
                    type="time"
                    v-model="contactReminderDraft.dueTime"
                  />
                  <span v-else>{{ formatContactReminderTime(rem) || '—' }}</span>
                </td>
                <td class="contact-reminders-contact-cell">
                  <div class="contact-reminders-contact">
                    <span class="contact-reminders-contact__name">{{ rem.contactName || 'Contatto' }}</span>
                    <span
                      v-if="rem.contactEmail"
                      class="contact-reminders-contact__meta promemoria-email"
                    >{{ rem.contactEmail }}</span>
                    <span v-if="rem.contactPhone" class="contact-reminders-contact__meta">{{ rem.contactPhone }}</span>
                  </div>
                </td>
                <td class="contact-reminders-note-cell">
                  <textarea
                    v-if="isContactReminderEditing(rem)"
                    v-model="contactReminderDraft.note"
                    class="note-textarea contact-reminders-note"
                    rows="3"
                    placeholder="Aggiungi nota"
                  ></textarea>
                  <span v-else>{{ rem.note || '—' }}</span>
                </td>
                <td class="contact-reminders-consultant-cell">
                  <div class="contact-reminders-consultant">
                    <input
                      v-if="isContactReminderEditing(rem)"
                      type="text"
                      v-model="contactReminderDraft.consultantName"
                      placeholder="Nome consulente"
                    />
                    <span v-else-if="rem.consultantName">{{ rem.consultantName }}</span>
                    <input
                      v-if="isContactReminderEditing(rem)"
                      type="text"
                      v-model="contactReminderDraft.consultantEmail"
                      placeholder="Email consulente"
                    />
                    <span v-else-if="rem.consultantEmail" class="contact-reminders-contact__meta">{{ rem.consultantEmail }}</span>
                    <span v-else>—</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <p v-else class="contact-reminders-empty">Nessun promemoria da mostrare.</p>
        </div>

        
        




        <!-- Messaggio fisso
        <div class="message-box2">
          <h2>Video per protocollo 25</h2>
<ul>
    <li>01: <a href="https://bit.ly/01protocollo25" target="_blank">https://bit.ly/01protocollo25</a></li>
    <li>02: <a href="https://bit.ly/02protocollo25" target="_blank">https://bit.ly/02protocollo25</a></li>
    <li>03: <a href="https://bit.ly/03protocollo25" target="_blank">https://bit.ly/03protocollo25</a></li>
  <li>04: <a href="https://bit.ly/04protocollo25" target="_blank">https://bit.ly/04protocollo25</a></li>
  </ul>
        </div>
 -->
        <!-- Sezione News -->
        <div v-if="newsList.length">
          <h2 class="news-title">Ultime News</h2>
          <div class="news-box" v-for="(news, index) in newsList" :key="index">
            <p>
              <span v-for="(part, i) in news" :key="i">
                <template v-if="part.type === 'text'">{{ part.content }}</template>
                <template v-else-if="part.type === 'link'">
                  <a :href="part.content" target="_blank" class="news-link">{{ part.content }}</a>
                </template>
              </span>
            </p>
          </div>
        </div>

        <!-- Messaggio fisso -->
        <div class="message-box">
          <h2>Fusco Fit Connect Update</h2>
          <p>Stiamo cercando di ottimizzare tutto il sistema, per renderlo veloce, stabile e performante.</p>
          <p>Vi ringraziamo per i vostri feedback, stiamo cercando di renderli tutti operativi.</p>
        </div>

        <!-- Modal aggiunta promemoria -->
        <dialog
          ref="newReminderDialog"
          class="staff-editor-dialog staff-reminder-create-dialog"
          aria-labelledby="dashboard-reminder-create-title"
          aria-describedby="dashboard-reminder-create-description"
          @cancel.prevent="closeAddReminderModal"
          @close="showAddModal = false"
          @click.self="handleAddReminderBackdrop"
        >
          <header class="staff-editor-header">
            <span class="material-icons staff-editor-heading-icon" aria-hidden="true">add_task</span>
            <div>
              <h2 id="dashboard-reminder-create-title">Nuovo promemoria</h2>
              <p id="dashboard-reminder-create-description">Pianifica l’attività e scegli a chi assegnarla.</p>
            </div>
            <button
              type="button"
              class="staff-editor-close staff-button-neutral"
              aria-label="Chiudi nuovo promemoria"
              title="Chiudi nuovo promemoria"
              @click="closeAddReminderModal"
              autofocus
            >
              <span class="material-icons" aria-hidden="true">close</span>
            </button>
          </header>

          <form class="staff-editor-form" @submit.prevent="addReminder">
            <div class="staff-editor-body">
              <fieldset class="staff-editor-section">
                <legend>Pianificazione</legend>
                <div class="staff-editor-grid staff-editor-grid--two">
                  <label class="staff-editor-field">
                    <span>Data e ora *</span>
                    <input type="datetime-local" v-model="newReminder.data" required />
                  </label>
                  <label class="staff-editor-field">
                    <span>Visibilità</span>
                    <select v-model="newReminder.tipoPromemoria">
                      <option value="pubblico">Pubblico</option>
                      <option value="privato">Privato</option>
                    </select>
                  </label>
                  <label class="staff-editor-field">
                    <span>Tipo di attività</span>
                    <select v-model="newReminder.tipo">
                      <option value="" disabled>Seleziona attività</option>
                      <option value="telefonata">Chiamata</option>
                      <option value="prima telefonata">Prima chiamata</option>
                      <option value="whatsapp">Whatsapp</option>
                      <option value="email">E-mail</option>
                      <option value="live">Dal vivo</option>
                      <option value="messaggio">Messaggio</option>
                      <option value="check confronto">Check di confronto</option>
                      <option value="check lavorare">Check lavorare</option>
                      <option value="ricontatto intermedio">Ricontatto intermedio</option>
                      <option value="ricontatto finale">Ricontatto finale</option>
                      <option value="recupero clienti fermi">Recupero clienti fermi</option>
                      <option value="altro">Altro</option>
                    </select>
                  </label>
                  <label class="staff-editor-field">
                    <span>Urgenza</span>
                    <select v-model="newReminder.urgenza">
                      <option value="" disabled>Seleziona urgenza</option>
                      <option value="bassa">Bassa</option>
                      <option value="media">Media</option>
                      <option value="alta">Alta</option>
                    </select>
                  </label>
                </div>
              </fieldset>

              <fieldset class="staff-editor-section">
                <legend>Persone e assegnazioni</legend>
                <div class="staff-editor-grid staff-editor-grid--two">
                  <label class="staff-editor-field">
                    <span>Email utente</span>
                    <input type="text" inputmode="email" v-model="newReminder.userEmail" placeholder="Email dell’utente" />
                  </label>
                  <label class="staff-editor-field">
                    <span>Collaboratori</span>
                    <input
                      type="text"
                      inputmode="email"
                      v-model="newReminder.assignedEmail"
                      placeholder="email1@mail.com, email2@mail.com"
                      aria-describedby="dashboard-reminder-collaborators-hint"
                    />
                    <small id="dashboard-reminder-collaborators-hint">Separa più indirizzi con una virgola.</small>
                  </label>
                </div>
              </fieldset>

              <label class="staff-editor-field staff-editor-field--wide">
                <span>Note</span>
                <textarea v-model="newReminder.note" rows="3" placeholder="Aggiungi le informazioni utili per l’attività"></textarea>
              </label>
            </div>

            <footer class="staff-editor-footer">
              <p>* Data e ora sono obbligatorie.</p>
              <div class="staff-editor-actions">
                <button type="button" class="staff-editor-button staff-editor-cancel staff-button-cancel" @click="closeAddReminderModal">Annulla</button>
                <button type="submit" class="staff-editor-button staff-editor-save staff-button-positive">
                  <span class="material-icons" aria-hidden="true">check</span>
                  <span>Salva</span>
                </button>
              </div>
            </footer>
          </form>
        </dialog>

        <div
          v-if="noteModalOpen"
          class="modal-overlay"
          role="dialog"
          aria-modal="true"
          aria-labelledby="reminder-note-modal-title"
          @click.self="closeReminderNoteModal"
        >
          <div class="reminder-note-modal">
            <div class="reminder-note-modal__head">
              <div>
                <span class="reminder-note-modal__kicker">Nota promemoria</span>
                <h3 id="reminder-note-modal-title">Leggi e modifica nota</h3>
                <p>{{ reminderNoteModalSubtitle }}</p>
              </div>
              <button
                type="button"
                class="reminder-note-modal__close"
                title="Chiudi"
                aria-label="Chiudi"
                :disabled="noteModalSaving"
                @click="closeReminderNoteModal"
              >
                <span class="material-icons" aria-hidden="true">close</span>
              </button>
            </div>

            <textarea
              v-model="noteModalDraft"
              class="reminder-note-modal__textarea"
              rows="9"
              placeholder="Scrivi la nota completa"
              :disabled="noteModalSaving"
            ></textarea>

            <div v-if="noteModalError" class="reminder-note-modal__error">
              {{ noteModalError }}
            </div>

            <div class="reminder-note-modal__actions">
              <button type="button" class="reminder-note-modal__secondary staff-button-cancel" :disabled="noteModalSaving" @click="closeReminderNoteModal">
                Annulla
              </button>
              <button type="button" class="reminder-note-modal__primary staff-button-positive" :disabled="noteModalSaving" @click="saveReminderNoteModal">
                <span class="material-icons" aria-hidden="true">save</span>
                {{ noteModalSaving ? 'Salvo...' : 'Salva nota' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import SidebarComponent from '../SidebarComponent.vue';
import DashboardBundleLinks from './DashboardBundleLinks.vue';
import { ref, watch, onMounted, computed, onUnmounted } from 'vue';
import { getAuth } from 'firebase/auth';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import {
  getFirestore,
  doc,
  getDoc,
  collection,
  query,
  where,
  onSnapshot,
  updateDoc,
  deleteDoc,
  deleteField,
  addDoc,
  getDocs,
  Timestamp,
  orderBy
} from 'firebase/firestore';

export default {
  name: 'DashboardGeneral',
  components: { SidebarComponent, DashboardBundleLinks },
  setup() {
    const auth = getAuth();
    const db = getFirestore();
    const router = useRouter();
    const store = useStore();

    const newsList = ref([]);
    const reminders = ref([]);
    const filterFrom = ref('');
    const filterTo = ref('');
    const appliedFrom = ref('');
    const appliedTo = ref('');
    const showHidden = ref(false);
    const showAddModal = ref(false);
    const newReminderDialog = ref(null);
    const filterFatto = ref('da fare');
    const noteModalOpen = ref(false);
    const noteModalReminder = ref(null);
    const noteModalDraft = ref('');
    const noteModalSaving = ref(false);
    const noteModalError = ref('');

    const getLoggedInUserEmail = user => String(
      user?.email
      || auth.currentUser?.email
      || store.getters.userEmail
      || localStorage.getItem('userEmail')
      || ''
    ).trim();
    const currentUserEmail = ref(getLoggedInUserEmail(auth.currentUser));
    const newReminder = ref({
      data: '',
      tipo: '',
      urgenza: '',
      note: '',
      userEmail: '',
      assignedEmail: currentUserEmail.value,
      tipoPromemoria: 'pubblico'
    });

    const contactReminders = ref([]);
    const contactRemindersLoading = ref(true);
    const showCompletedContactReminders = ref(false);
    const contactReminderNameSearch = ref('');
    const contactReminderPhoneSearch = ref('');
    const contactReminderUserCache = new Map();
    const editingContactReminderId = ref('');
    const contactReminderDraft = ref({
      dueDate: '',
      dueTime: '',
      note: '',
      consultantName: '',
      consultantEmail: '',
    });
    const resolvingContactReminderProfiles = ref({});
    let unsubscribeContactReminders = null;
    let unsubscribeReminders = null;
    let unsubscribeAuth = null;

    const goToPromemoriaPubblico = () => {
  router.push('/promemoria-pubblico');
};

    const goToContatti = () => {
  router.push('/contatti-list');
};

    const goToOrdini = () => {
  router.push('/order-list-new');
};

    const goToNotifiche10Giorni = () => {
  router.push('/notifiche-10-giorni');
};

    const goToNotifiche24Giorni = () => {
  router.push('/notifiche-24-giorni');
};

    const goToNotifiche40Giorni = () => {
  router.push('/notifiche-40-giorni');
};

    const goToProgrammiDaOscurare = () => {
  router.push('/programmi-da-oscurare');
};

    const goToOrdersAccounting = () => {
      router.push('/orders-accounting');
    };

    const goToQuestionari = () => {
  router.push('/questionari-users');
};

    const goToQuestionariScaduti = () => {
  router.push('/questionari-users-scaduti');
};

    const goToQuestionariManuali = () => {
  router.push('/questionari-manuali');
};

    const goToPercorsiNonIniziati = () => {
  router.push('/percorsi-non-iniziati');
};

    const goToUsersExpiringList = () => {
  router.push('/users-expiring-list');
};

    const goToPublicBookings = () => {
      router.push('/prenotazioni-pubbliche');
    };

    const goToConsulenze = () => {
  router.push('/consulenze-riepilogo');
};

    const goToCalendari = () => {
  router.push('/calendari-eventi');
};

const getDateString = (ts) => {
  const d = parseDate(ts);
  return d.toISOString().split('T')[0];
};

const getTimeString = (ts) => {
  const d = parseDate(ts);
  const hh = String(d.getHours()).padStart(2, '0');
  const mi = String(d.getMinutes()).padStart(2, '0');
  return `${hh}:${mi}`;
};


const updateReminderDate = async (m, newDateStr, newTimeStr) => {
  try {
    const d = parseDate(m.data);
    let year = d.getFullYear();
    let month = d.getMonth();
    let date = d.getDate();
    let hours = d.getHours();
    let minutes = d.getMinutes();

    if (newDateStr) {
      const [y, mth, dte] = newDateStr.split('-').map(Number);
      year = y; month = mth - 1; date = dte;
    }

    if (newTimeStr) {
      const [h, m] = newTimeStr.split(':').map(Number);
      hours = h; minutes = m;
    }

    const newDate = new Date(year, month, date, hours, minutes);
    await updateDoc(doc(db, 'comunicazioni', m.id), { data: newDate });
    m.data = newDate;
  } catch (e) {
    console.error('Errore updateReminderDate:', e);
  }
};



    const viewUserProfile = userId => {
      router.push({ name: 'UserDetails', params: { userId } });
    };

    const viewUserProfileInNewTab = userId => {
      if (!userId) return;
      const href = router.resolve({ name: 'UserDetails', params: { userId } }).href;
      window.open(href, '_blank', 'noopener');
    };

    const parseContentWithLinks = text => {
      const urlPattern = /(https?:\/\/[^\s]+)/g;
      return text
        .split(urlPattern)
        .filter(Boolean)
        .map(part =>
          urlPattern.test(part)
            ? { type: 'link', content: part }
            : { type: 'text', content: part }
        );
    };

    const parseDate = field => (field?.toDate ? field.toDate() : new Date(field));
    const formatDate = field => {
      const dt = parseDate(field);
      const dd = String(dt.getDate()).padStart(2, '0');
      const mm = String(dt.getMonth() + 1).padStart(2, '0');
      const yy = dt.getFullYear();
      const hh = String(dt.getHours()).padStart(2, '0');
      const mi = String(dt.getMinutes()).padStart(2, '0');
      return `${dd}/${mm}/${yy} ${hh}:${mi}`;
    };

    const isValidDate = (date) => date instanceof Date && !Number.isNaN(date.getTime());

    const normalizeEmail = (value = '') => String(value || '').trim().toLowerCase();
    const normalizeSearchText = (value = '') => String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ');
    const normalizePhoneDigits = (value = '') => String(value || '').replace(/\D/g, '');
    const stripItalianPrefix = (digits = '') => {
      if (digits.startsWith('0039') && digits.length > 10) return digits.slice(4);
      if (digits.startsWith('39') && digits.length > 10) return digits.slice(2);
      return digits;
    };
    const buildPhoneSearchVariants = (value = '') => {
      const digits = normalizePhoneDigits(value);
      const local = stripItalianPrefix(digits);
      return Array.from(new Set([
        value ? String(value).trim() : '',
        digits,
        local,
        local ? `39${local}` : '',
        local ? `+39${local}` : '',
      ].filter(Boolean)));
    };
    const normalizePhoneForSearch = (value = '') => stripItalianPrefix(normalizePhoneDigits(value));

    const contactReminderMatchesNameSearch = (rem = {}, rawSearch = '') => {
      const search = normalizeSearchText(rawSearch);
      if (!search) return true;
      const contactName = normalizeSearchText([
        rem.contactName,
        rem.firstName,
        rem.lastName,
        rem.name,
        rem.surname,
        rem.nome,
        rem.cognome,
      ].filter(Boolean).join(' '));
      return contactName.includes(search);
    };

    const contactReminderMatchesPhoneSearch = (rem = {}, rawSearch = '') => {
      const searchDigits = normalizePhoneDigits(rawSearch);
      if (!searchDigits) return true;
      const normalizedSearch = normalizePhoneForSearch(rawSearch);
      const phoneValues = [
        rem.contactPhone,
        rem.phone,
        rem.telefono,
        rem.mobile,
        rem.cellulare,
      ];

      return phoneValues.some((value) => {
        const digits = normalizePhoneDigits(value);
        if (!digits) return false;
        const normalizedPhone = normalizePhoneForSearch(value);
        return (
          digits.includes(searchDigits)
          || digits.includes(normalizedSearch)
          || normalizedPhone.includes(searchDigits)
          || normalizedPhone.includes(normalizedSearch)
        );
      });
    };

    const findFirstUserUidByField = async (field, values) => {
      const list = Array.from(new Set((values || []).map(v => String(v || '').trim()).filter(Boolean)));
      for (let i = 0; i < list.length; i += 10) {
        const chunk = list.slice(i, i + 10);
        const snap = await getDocs(query(collection(db, 'users'), where(field, 'in', chunk)));
        if (!snap.empty) return snap.docs[0].id;
      }
      return '';
    };

    const resolveContactReminderUserUid = async (data = {}) => {
      const explicitUid = data.userProfileUid || data.matchedUserUid || data.userUid || data.uid || '';
      if (explicitUid) return explicitUid;

      const email = normalizeEmail(data.contactEmail);
      if (email) {
        const emailCacheKey = `email:${email}`;
        if (contactReminderUserCache.has(emailCacheKey)) {
          return contactReminderUserCache.get(emailCacheKey);
        }
        const uid = await findFirstUserUidByField('emailLower', [email])
          || await findFirstUserUidByField('email', [email]);
        contactReminderUserCache.set(emailCacheKey, uid || '');
        if (uid) return uid;
      }

      const phoneVariants = buildPhoneSearchVariants(data.contactPhone);
      const phoneCacheKey = `phone:${phoneVariants[0] || ''}`;
      if (phoneVariants.length && contactReminderUserCache.has(phoneCacheKey)) {
        return contactReminderUserCache.get(phoneCacheKey);
      }
      const phoneUid = await findFirstUserUidByField('phone', phoneVariants)
        || await findFirstUserUidByField('telefono', phoneVariants);
      if (phoneVariants.length) contactReminderUserCache.set(phoneCacheKey, phoneUid || '');
      return phoneUid || '';
    };

    const canOpenContactReminderProfile = (rem = {}) => !!(
      rem.userProfileUid
      || rem.matchedUserUid
      || rem.userUid
      || rem.uid
      || rem.contactEmail
      || rem.contactPhone
    );

    const isContactReminderProfileLoading = (rem = {}) => !!resolvingContactReminderProfiles.value[rem.id];

    const openContactReminderUserProfile = async (rem = {}) => {
      if (!canOpenContactReminderProfile(rem) || isContactReminderProfileLoading(rem)) return;
      try {
        resolvingContactReminderProfiles.value = {
          ...resolvingContactReminderProfiles.value,
          [rem.id]: true,
        };
        const uid = await resolveContactReminderUserUid(rem);
        if (!uid) {
          alert('Profilo utente non trovato per questo contatto.');
          return;
        }
        rem.userProfileUid = uid;
        if (rem.id) {
          try {
            await updateDoc(doc(db, 'contattiPromemoria', rem.id), { userProfileUid: uid });
          } catch (error) {
            console.warn('Impossibile salvare userProfileUid sul promemoria contatto:', error);
          }
        }
        viewUserProfile(uid);
      } catch (error) {
        console.error('Errore apertura profilo promemoria contatto:', error);
      } finally {
        const next = { ...resolvingContactReminderProfiles.value };
        delete next[rem.id];
        resolvingContactReminderProfiles.value = next;
      }
    };

    const fetchNews = async () => {
      try {
        const snap = await getDoc(doc(db, 'newsdashboard', 'so01Q7FzKN3ztY41atxH'));
        if (!snap.exists()) return;
        const data = snap.data();
        newsList.value = Object.keys(data)
          .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
          .map(k => parseContentWithLinks(data[k]));
      } catch (e) {
        console.error('Errore fetchNews:', e);
      }
    };

    const fetchReminders = email => {
      if (unsubscribeReminders) unsubscribeReminders();
      const q = query(collection(db, 'comunicazioni'));
      unsubscribeReminders = onSnapshot(q, snap => {
        const arr = [];
        snap.docs.forEach(d => {
          const data = d.data();
          if (data.assignedEmail) {
            const emails = data.assignedEmail.split(',').map(e => e.trim().toLowerCase());
            if (emails.includes(email.toLowerCase())) {
              arr.push({ id: d.id, ...data, userEmail: '' });
            }
          }
        });

        Promise.all(
          arr.map(async rem => {
            if (rem.uid) {
              const uSnap = await getDoc(doc(db, 'users', rem.uid));
              if (uSnap.exists()) rem.userEmail = uSnap.data().email;
            }
            return rem;
          })
        ).then(resolved => {
          reminders.value = resolved.sort((a, b) => parseDate(a.data) - parseDate(b.data));
        });
      });
    };

    const fetchContactReminders = () => {
      if (unsubscribeContactReminders) unsubscribeContactReminders();
      contactRemindersLoading.value = true;
      const remindersRef = collection(db, 'contattiPromemoria');
      const q = query(remindersRef, orderBy('dueAt', 'asc'));
      unsubscribeContactReminders = onSnapshot(q, snap => {
        const items = snap.docs.map((d) => {
          const data = d.data();
          const dueAtDate = data.dueAt?.toDate ? data.dueAt.toDate() : (data.dueAt ? new Date(data.dueAt) : null);
          return {
            id: d.id,
            ...data,
            dueAtDate,
          };
        });
        items.sort((a, b) => {
          const aTime = a.dueAtDate ? a.dueAtDate.getTime() : 0;
          const bTime = b.dueAtDate ? b.dueAtDate.getTime() : 0;
          return aTime - bTime;
        });
        contactReminders.value = items;
        contactRemindersLoading.value = false;
      }, (error) => {
        console.error('Errore fetchContactReminders:', error);
        contactReminders.value = [];
        contactRemindersLoading.value = false;
      });
    };

    const applyFilters = () => {
      appliedFrom.value = filterFrom.value;
      appliedTo.value = filterTo.value;
    };

    const clearDateFilters = () => {
      filterFrom.value = '';
      filterTo.value = '';
      appliedFrom.value = '';
      appliedTo.value = '';
    };

    const filteredReminders = computed(() =>
      reminders.value.filter(m => {
        if (!showHidden.value && m.visibilita === false) return false;
        const dt = parseDate(m.data);
        if (appliedFrom.value && dt < new Date(appliedFrom.value)) return false;
        if (appliedTo.value) {
          const t = new Date(appliedTo.value);
          t.setHours(23, 59, 59, 999);
          if (dt > t) return false;
        }
        if (filterFatto.value && m.fatto !== filterFatto.value) return false;
        return true;
      })
    );

    const reminderNoteModalSubtitle = computed(() => {
      const rem = noteModalReminder.value;
      if (!rem) return '';
      const pieces = [
        rem.userEmail || 'Utente non disponibile',
      ];
      try {
        pieces.push(formatDate(rem.data));
      } catch {
        // La data e solo informativa: se non e valida, non blocca la modifica.
      }
      return pieces.filter(Boolean).join(' - ');
    });

    const visibleContactReminders = computed(() => {
      const baseItems = showCompletedContactReminders.value
        ? contactReminders.value
        : contactReminders.value.filter(rem => !rem.done);

      return baseItems.filter((rem) => (
        contactReminderMatchesNameSearch(rem, contactReminderNameSearch.value)
        && contactReminderMatchesPhoneSearch(rem, contactReminderPhoneSearch.value)
      ));
    });

    const clearContactReminderSearch = () => {
      contactReminderNameSearch.value = '';
      contactReminderPhoneSearch.value = '';
    };

    const getContactReminderDate = (rem) => {
      const date = rem?.dueAtDate || parseDate(rem?.dueAt);
      return isValidDate(date) ? date : null;
    };

    const getContactReminderDateString = (rem) => {
      const date = getContactReminderDate(rem);
      if (!date) return '';
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const getContactReminderTimeString = (rem) => {
      const date = getContactReminderDate(rem);
      if (!date) return '';
      const hh = String(date.getHours()).padStart(2, '0');
      const mi = String(date.getMinutes()).padStart(2, '0');
      return `${hh}:${mi}`;
    };

    const formatContactReminderDate = (rem) => {
      const date = getContactReminderDate(rem);
      if (!date) return '';
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      return `${dd}/${mm}/${date.getFullYear()}`;
    };

    const formatContactReminderTime = (rem) => getContactReminderTimeString(rem);

    const isContactReminderEditing = (rem = {}) => editingContactReminderId.value === rem.id;

    const startContactReminderEdit = (rem = {}) => {
      editingContactReminderId.value = rem.id || '';
      contactReminderDraft.value = {
        dueDate: getContactReminderDateString(rem),
        dueTime: getContactReminderTimeString(rem),
        note: rem.note || '',
        consultantName: rem.consultantName || '',
        consultantEmail: rem.consultantEmail || '',
      };
    };

    const cancelContactReminderEdit = () => {
      editingContactReminderId.value = '';
      contactReminderDraft.value = {
        dueDate: '',
        dueTime: '',
        note: '',
        consultantName: '',
        consultantEmail: '',
      };
    };

    const saveContactReminderEdit = async (rem = {}) => {
      if (!rem?.id || !isContactReminderEditing(rem)) return;
      try {
        const draft = contactReminderDraft.value || {};
        const current = getContactReminderDate(rem) || new Date();
        const [year, month, day] = (draft.dueDate || getContactReminderDateString(rem)).split('-').map(Number);
        const [hours, minutes] = (draft.dueTime || getContactReminderTimeString(rem) || '00:00').split(':').map(Number);
        const nextDueAt = new Date(
          Number.isFinite(year) ? year : current.getFullYear(),
          Number.isFinite(month) ? month - 1 : current.getMonth(),
          Number.isFinite(day) ? day : current.getDate(),
          Number.isFinite(hours) ? hours : current.getHours(),
          Number.isFinite(minutes) ? minutes : current.getMinutes(),
        );
        if (!isValidDate(nextDueAt)) {
          alert('Data promemoria non valida.');
          return;
        }
        const note = String(draft.note || '').trim();
        const consultantName = String(draft.consultantName || '').trim();
        const consultantEmail = normalizeEmail(draft.consultantEmail);
        const dueAt = Timestamp.fromDate(nextDueAt);
        await updateDoc(doc(db, 'contattiPromemoria', rem.id), {
          dueAt,
          note,
          consultantName,
          consultantEmail,
        });
        rem.dueAt = dueAt;
        rem.dueAtDate = nextDueAt;
        rem.note = note;
        rem.consultantName = consultantName;
        rem.consultantEmail = consultantEmail;
        cancelContactReminderEdit();
      } catch (error) {
        console.error('Errore saveContactReminderEdit:', error);
      }
    };

    const updateReminderField = async (rem, field) => {
      try {
        await updateDoc(doc(db, 'comunicazioni', rem.id), {
          [field]: rem[field]
        });
      } catch (e) {
        console.error('Errore updateReminderField:', e);
      }
    };

    const openReminderNoteModal = (rem = {}) => {
      noteModalReminder.value = rem;
      noteModalDraft.value = String(rem.note || '');
      noteModalError.value = '';
      noteModalOpen.value = true;
    };

    const closeReminderNoteModal = () => {
      if (noteModalSaving.value) return;
      noteModalOpen.value = false;
      noteModalReminder.value = null;
      noteModalDraft.value = '';
      noteModalError.value = '';
    };

    const saveReminderNoteModal = async () => {
      const rem = noteModalReminder.value;
      if (!rem?.id) {
        noteModalError.value = 'Promemoria non valido.';
        return;
      }

      noteModalSaving.value = true;
      noteModalError.value = '';
      try {
        const note = String(noteModalDraft.value || '');
        await updateDoc(doc(db, 'comunicazioni', rem.id), { note });
        rem.note = note;
        noteModalSaving.value = false;
        closeReminderNoteModal();
      } catch (e) {
        console.error('Errore saveReminderNoteModal:', e);
        noteModalError.value = 'Non riesco a salvare la nota.';
      } finally {
        noteModalSaving.value = false;
      }
    };

    const toggleContactReminderDone = async (rem, value) => {
      try {
        await updateDoc(doc(db, 'contattiPromemoria', rem.id), {
          done: value,
          doneAt: value ? Timestamp.now() : null,
        });
      } catch (error) {
        console.error('Errore toggleContactReminderDone:', error);
      }
    };

    const deleteContactReminder = async (rem) => {
      if (!confirm('Vuoi eliminare questo promemoria?')) return;
      try {
        await deleteDoc(doc(db, 'contattiPromemoria', rem.id));
      } catch (error) {
        console.error('Errore deleteContactReminder:', error);
      }
    };

    const deleteReminder = async reminder => {
      if (!confirm('Sei sicuro di voler cancellare questo promemoria?')) return;
      try {
        const id = typeof reminder === 'object' ? reminder.id : reminder;
        if (!id) return;
        const reminderRef = doc(db, 'comunicazioni', id);
        let reminderData = typeof reminder === 'object' ? reminder : null;
        if (!reminderData?.publicBookingId) {
          const reminderSnap = await getDoc(reminderRef);
          reminderData = reminderSnap.exists() ? { id: reminderSnap.id, ...reminderSnap.data() } : reminderData;
        }

        await deleteDoc(reminderRef);

        if (reminderData?.publicBookingId) {
          try {
            const bookingRef = doc(db, 'public_bookings', reminderData.publicBookingId);
            const bookingSnap = await getDoc(bookingRef);
            const currentReminderId = bookingSnap.exists() ? (bookingSnap.data()?.followUpReminderId || '') : '';
            if (!currentReminderId || currentReminderId === id) {
              await updateDoc(bookingRef, {
                followUpReminderId: deleteField(),
                followUpReminderAt: deleteField(),
              });
            }
          } catch (cleanupError) {
            console.warn('Promemoria cancellato, ma non riesco a pulire il riferimento sulla prenotazione:', cleanupError);
          }
        }
      } catch (e) {
        console.error('Errore deleteReminder:', e);
      }
    };

    const toggleReminderVisibility = async rem => {
      try {
        const newVis = !rem.visibilita;
        await updateDoc(doc(db, 'comunicazioni', rem.id), { visibilita: newVis });
        rem.visibilita = newVis;
      } catch (e) {
        console.error('Errore toggleReminderVisibility:', e);
      }
    };

    watch(showAddModal, visible => {
      const dialog = newReminderDialog.value;
      if (!dialog) return;
      if (visible && !dialog.open) dialog.showModal();
      else if (!visible && dialog.open) dialog.close();
    }, { flush: 'post' });

    const closeAddReminderModal = () => {
      showAddModal.value = false;
    };

    const handleAddReminderBackdrop = event => {
      const rect = newReminderDialog.value?.getBoundingClientRect();
      if (rect && (
        event.clientX < rect.left
        || event.clientX > rect.right
        || event.clientY < rect.top
        || event.clientY > rect.bottom
      )) {
        closeAddReminderModal();
      }
    };

    const openAddReminderModal = () => {
      currentUserEmail.value = getLoggedInUserEmail(auth.currentUser);
      if (!newReminder.value.assignedEmail.trim()) {
        newReminder.value.assignedEmail = currentUserEmail.value;
      }
      showAddModal.value = true;
    };
    const toggleShowHidden = () => (showHidden.value = !showHidden.value);

    const addReminder = async () => {
      if (!newReminder.value.data) {
        alert('Per favore, inserisci data e ora del promemoria.');
        return;
      }

      let uidToAssign = null;
      try {
        const usersQ = query(collection(db, 'users'), where('email', '==', newReminder.value.userEmail));
        const usersSnap = await getDocs(usersQ);
        if (!usersSnap.empty) {
          uidToAssign = usersSnap.docs[0].id;
        } else {
          alert("Nessun utente trovato con l'email fornita.");
          return;
        }
      } catch (err) {
        console.error('Errore ricerca utente:', err);
        return;
      }

      try {
        await addDoc(collection(db, 'comunicazioni'), {
          uid: uidToAssign,
          data: Timestamp.fromDate(new Date(newReminder.value.data)),
          tipo: newReminder.value.tipo,
          urgenza: newReminder.value.urgenza,
          note: newReminder.value.note,
          assignedEmail: newReminder.value.assignedEmail,
          tipoPromemoria: newReminder.value.tipoPromemoria,
          visibilita: true,
          fatto: 'da fare'
        });
        closeAddReminderModal();
        newReminder.value = {
          data: '',
          tipo: '',
          urgenza: '',
          note: '',
          userEmail: '',
          assignedEmail: currentUserEmail.value,
          tipoPromemoria: 'pubblico'
        };
      } catch (e) {
        console.error('Errore addReminder:', e);
      }
    };

    onMounted(() => {
      fetchNews();
      unsubscribeAuth = auth.onAuthStateChanged(user => {
        currentUserEmail.value = getLoggedInUserEmail(user);
        if (!showAddModal.value) {
          newReminder.value.assignedEmail = currentUserEmail.value;
        }
        if (currentUserEmail.value) {
          fetchReminders(currentUserEmail.value);
        } else {
          if (unsubscribeReminders) unsubscribeReminders();
          unsubscribeReminders = null;
          reminders.value = [];
        }
      });
      fetchContactReminders();
    });

    onUnmounted(() => {
      if (unsubscribeContactReminders) unsubscribeContactReminders();
      if (unsubscribeReminders) unsubscribeReminders();
      if (unsubscribeAuth) unsubscribeAuth();
    });

    return {
      newsList,
      reminders,
      filterFrom,
      filterTo,
      appliedFrom,
      appliedTo,
      showHidden,
      showAddModal,
      newReminderDialog,
      noteModalOpen,
      noteModalDraft,
      noteModalSaving,
      noteModalError,
      reminderNoteModalSubtitle,
      newReminder,
      filteredReminders,
      formatDate,
      applyFilters,
      clearDateFilters,
      deleteReminder,
      updateReminderField,
      openReminderNoteModal,
      closeReminderNoteModal,
      saveReminderNoteModal,
      toggleReminderVisibility,
      openAddReminderModal,
      closeAddReminderModal,
      handleAddReminderBackdrop,
      toggleShowHidden,
      addReminder,
      viewUserProfile,
      viewUserProfileInNewTab,
      filterFatto,
      goToPromemoriaPubblico,
      getDateString,
      getTimeString,
      updateReminderDate,
      goToQuestionari,
      goToOrdini,
      goToNotifiche10Giorni,
      goToNotifiche24Giorni,
      goToNotifiche40Giorni,
      goToProgrammiDaOscurare,
      goToOrdersAccounting,
      goToQuestionariScaduti,
      goToQuestionariManuali,
      goToPercorsiNonIniziati,
      goToUsersExpiringList,
      goToPublicBookings,
      goToConsulenze,
      goToCalendari,
      goToContatti,
      contactReminders,
      contactRemindersLoading,
      visibleContactReminders,
      showCompletedContactReminders,
      contactReminderNameSearch,
      contactReminderPhoneSearch,
      clearContactReminderSearch,
      contactReminderDraft,
      canOpenContactReminderProfile,
      isContactReminderProfileLoading,
      openContactReminderUserProfile,
      formatContactReminderDate,
      formatContactReminderTime,
      isContactReminderEditing,
      startContactReminderEdit,
      cancelContactReminderEdit,
      saveContactReminderEdit,
      toggleContactReminderDone,
      deleteContactReminder
    };
  }
};
</script>




<style scoped>

table {
  padding: 0px!important;
}
/* ===== Quick pastel cards ===== */
.quick-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin: 18px 0 28px;
}
@media (max-width: 900px) {
  .quick-grid { grid-template-columns: 1fr; }
  .notify-grid { grid-template-columns: 1fr; }
}

.quick-card {
  display: flex;
  align-items: center;
  gap: 14px;
  border: none;
  border-radius: 16px;
  padding: 27px 18px;
  background: #fff;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(16,24,40,.08);
  transition: transform .12s ease, box-shadow .12s ease, background-color .12s ease;
  text-align: left;
}
.quick-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(16,24,40,.12);
}

.notify-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin: 12px 0 18px;
}

.notify-card {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  padding: 14px 16px;
  border-radius: 14px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: linear-gradient(135deg, #f1f5f9, #e2e8f0);
  color: #0f172a;
  box-shadow: 0 10px 24px -18px rgba(15, 23, 42, 0.6);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
  text-align: left;
}

.notify-card:hover {
  transform: translateY(-1px);
  border-color: rgba(15, 23, 42, 0.18);
  box-shadow: 0 14px 28px -18px rgba(15, 23, 42, 0.7);
}

.notify-card--disabled {
  cursor: default;
  opacity: 0.7;
  filter: grayscale(0.2);
  pointer-events: none;
}

.notify-icon {
  font-size: 28px;
  background: #0f172a;
  color: #f8fafc;
  border-radius: 10px;
  padding: 6px;
}

.notify-title {
  font-weight: 700;
  font-size: 0.98rem;
}

.notify-sub {
  font-size: 0.82rem;
  color: #475569;
}

@media (max-width: 768px) {
  .dashboard-notifications-mobile {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  .dashboard-notifications-mobile .notify-card {
    min-width: 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 14px 12px;
  }

  .dashboard-notifications-mobile .notify-icon {
    flex: 0 0 auto;
    font-size: 24px;
  }

  .dashboard-notifications-mobile .notify-text {
    min-width: 0;
    max-width: 100%;
  }

  .dashboard-notifications-mobile .notify-title {
    font-size: 15px;
    line-height: 1.3;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .dashboard-notifications-mobile .notify-sub {
    margin-top: 4px;
    font-size: 12px;
    line-height: 1.4;
  }
}

.quick-icon {
  font-size: 28px;
  border-radius: 12px;
  padding: 10px;
  flex: 0 0 auto;
}

/* testi */
.quick-text { display: grid; gap: 2px; }
.quick-title { font-weight: 700; color: #0f172a; }
.quick-sub   { font-size: .92rem; color: #475569; }

.quick-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #dc2626;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

/* palette pastello */
.q-blue   .quick-icon { background: #e6efff; color: #1d4ed8; }
.q-orange .quick-icon { background: #fff1e6; color: #b45309; }
.q-green  .quick-icon { background: #eaf7ee; color: #15803d; }
.q-purple .quick-icon { background: #f3e8ff; color: #7c3aed; }

/* subtle background tint on hover */
.q-blue:hover   { background: #f6f9ff; }
.q-orange:hover { background: #fff7ef; }
.q-green:hover  { background: #f4fbf6; }
.q-purple:hover { background: #f7f2ff; }

/* ===== Secondary buttons ===== */
.create-user-button_white {
  padding: 13px 15px;
  border-radius: 13px;
  background-color: #e3e3e3;
  color: #0f0f0f;
  font-size: 1rem;
  cursor: pointer;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* ===== Info box (se li usi) ===== */
.info-box {
  background: #f3f3f3;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  border-radius: 6px;
  padding: 1rem 1.5rem;
  margin: 1.5rem 0 30px;
}
.info-box h3 {
  text-align: center;
  font-size: 1.2rem;
  color: #333;
  margin-bottom: 1rem;
}
.info-box ul { list-style: none; padding: 0; margin: 0; }
.info-box ul li {
  display: flex; align-items: center;
  padding: .5rem 0; border-bottom: 1px solid #eee;
  font-size: 1rem; color: #333;
}
.info-box ul li:last-child { border-bottom: none; }
.info-box ul li a {
  margin-left: .5rem; color: #007bff; text-decoration: none; font-weight: 500;
}
.info-box ul li a:hover { text-decoration: underline; color: #0056b3; }

/* ===== Modale ===== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-content {
  background:#202020;
  padding: 20px;
  border-radius: 8px;
  width: 470px;
  max-width: calc(100vw - 32px);
  margin-left: 220px; /* mantengo il tuo offset */
}
.modal-actions { display: flex; gap: 10px; margin-top: 10px; }
.modal-content label { display: block; margin-bottom: 10px; }

/* ===== Sezione promemoria (titolo + filtri) ===== */
.promemoria-container {
  margin-top: 60px;
  margin-bottom: 30px;
}
.promemoria-container h2 {
  color: #000000;
}

/* filtri (lasciati come sono) */
.filters {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 12px;
}
.filters label { font-weight: bold; }
.apply-btn {
  background: #009b00; color: white; border: none;
  padding: 4px 12px; border-radius: 4px; cursor: pointer;
}
.apply-btn:hover { background: #c36c00; }
.clear-btn {
  background: none; border: 1px solid #ccc; padding: 4px 8px;
  border-radius: 4px; cursor: pointer;
}
.clear-btn:hover { background: #f5f5f5; }

/* =========================================================
   TABELLA PROMEMORIA — versione minimal/densa
   (sostituisce la tua precedente definizione tabella)
   ========================================================= */
.promemoria-container table{
  width:100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;            /* ellissi su celle lunghe */
  border: 1px solid #ECEFF3;
  border-radius: 10px;
  overflow: hidden;               /* arrotondamento sul bordo */
}
.promemoria-container thead th{
  background:#F7F9FC;
  color:#111;
  font-weight:700;
  padding:10px 8px;
  border-bottom:1px solid #ECEFF3;
  text-align:left;
  font-size:.92rem;
}
.promemoria-container tbody td{
  padding:8px;
  border-bottom:1px solid #F0F2F5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size:.94rem;
  color:#111;
}
.promemoria-container tbody tr:last-child td{ border-bottom:none; }

/* colonne più lunghe: Utente (4) e Note (7) */
.promemoria-container th:nth-child(4),
.promemoria-container td:nth-child(4){ max-width: 240px; }
.promemoria-container th:nth-child(7),
.promemoria-container td:nth-child(7){ max-width: 260px; }

/* input/select “piatti” e compatti dentro le celle */
.promemoria-container td input[type="date"],
.promemoria-container td input[type="time"],
.promemoria-container td input[type="text"],
.promemoria-container td select{
  height: 32px;
  padding: 0 8px;
  font-size: .9rem;
  border: 1px solid #DCDFE4;
  border-radius: 6px;
  background: #fff;
  outline: none;
  box-shadow: none;
  max-width: 91%;
}

/* orario super-minimal (niente spinner/glow) */
.promemoria-container td input[type="time"]{
  -webkit-appearance: none;
  appearance: none;
}
.promemoria-container td input[type="time"]::-webkit-clear-button,
.promemoria-container td input[type="time"]::-webkit-inner-spin-button{
  display:none;
}
.promemoria-container td input[type="time"]::-webkit-calendar-picker-indicator{
  opacity:.6; filter:grayscale(1);
}

/* note a piena larghezza cella */
.promemoria-container .note-textarea{ width:100%; }

.reminder-note-editor {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 34px;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.promemoria-container .reminder-note-editor .note-textarea,
.promemoria-table .reminder-note-editor .note-textarea {
  width: 100%;
  min-width: 0;
  max-width: none;
  box-sizing: border-box;
}

.reminder-note-open {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  min-width: 34px;
  border: 1px solid rgba(148, 163, 184, 0.5);
  border-radius: 50%;
  background: #ffffff;
  color: #1d4ed8;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease, transform 0.18s ease;
}

.reminder-note-open .material-icons {
  font-size: 18px;
}

.reminder-note-open:hover {
  transform: translateY(-1px);
  border-color: #93c5fd;
  background: #eff6ff;
  color: #1e40af;
}

.reminder-note-modal {
  box-sizing: border-box;
  width: min(560px, calc(100vw - 32px));
  max-height: calc(100vh - 48px);
  overflow: auto;
  border-radius: 18px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: #ffffff;
  color: #0f172a;
  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.28);
  padding: 20px;
}

.reminder-note-modal__head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid #e2e8f0;
}

.reminder-note-modal__kicker {
  display: inline-flex;
  margin-bottom: 6px;
  color: #1d4ed8;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.reminder-note-modal h3 {
  margin: 0;
  color: #0f172a;
  font-size: 1.1rem;
}

.reminder-note-modal p {
  margin: 6px 0 0;
  color: #64748b;
  font-size: 0.9rem;
}

.reminder-note-modal__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #334155;
  cursor: pointer;
}

.reminder-note-modal__close:hover:not(:disabled) {
  background: #eff6ff;
  color: #1d4ed8;
}

.reminder-note-modal__textarea {
  box-sizing: border-box;
  width: 100%;
  min-height: 190px;
  resize: vertical;
  border: 1px solid rgba(148, 163, 184, 0.5);
  border-radius: 14px;
  padding: 12px 14px;
  color: #0f172a;
  background: #ffffff;
  font-size: 0.96rem;
  line-height: 1.45;
}

.reminder-note-modal__textarea:focus {
  outline: none;
  border-color: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.16);
}

.reminder-note-modal__error {
  margin-top: 10px;
  color: #b91c1c;
  font-weight: 700;
  font-size: 0.9rem;
}

.reminder-note-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 14px;
}

.reminder-note-modal__secondary,
.reminder-note-modal__primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 40px;
  border-radius: 12px;
  padding: 0 14px;
  font-weight: 800;
  cursor: pointer;
}

.reminder-note-modal__secondary {
  border: 1px solid #dbe3ef;
  background: #ffffff;
  color: #334155;
}

.reminder-note-modal__primary {
  border: 1px solid #22c55e;
  background: #22c55e;
  color: #ffffff;
}

.reminder-note-modal__primary .material-icons {
  font-size: 18px;
}

.reminder-note-modal__secondary:disabled,
.reminder-note-modal__primary:disabled,
.reminder-note-modal__close:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* ===== News & messaggi fissi ===== */
.message-box {
  background-color: #4CAF50;
  color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 20px 0 70px;
}
.message-box2 {
  background-color: #6a6c6b;
  color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 20px 0 70px;
}
.news-title { color: #000000; }
.news-box {
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  margin-top: 15px;
  border-left: 10px solid #de7e00;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.news-link { color: #4CAF50; text-decoration: underline; }
.news-link:hover { text-decoration: none; }

.contact-reminders-card {
  margin: 20px 0 32px;
  padding: 20px 22px;
  background: #ffffff;
  border-radius: 18px;
  overflow-x: auto;
}
.contact-reminders-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}
.contact-reminders-card__header h2 {
  margin: 0;
}
.contact-reminders-card__toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid #d4dff5;
  background: #f2f6ff;
  color: #1d4ed8;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.2s ease;
}
.contact-reminders-card__toggle:hover {
  background: rgba(29, 78, 216, 0.15);
}
.contact-reminders-search {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  margin: 0 0 16px;
  padding: 12px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 16px;
  background: #f8fafc;
}
.contact-reminders-search__field {
  display: flex;
  flex: 1 1 240px;
  min-width: 220px;
  flex-direction: column;
  gap: 6px;
  color: #334155;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.contact-reminders-search__field input {
  box-sizing: border-box;
  width: 100%;
  min-height: 40px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  border-radius: 12px;
  background: #ffffff;
  color: #0f172a;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0;
  padding: 8px 12px;
}
.contact-reminders-search__field input:focus {
  outline: none;
  border-color: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.18);
}
.contact-reminders-search__reset {
  width: 40px;
  height: 40px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  border-radius: 50%;
  background: #ffffff;
  color: #1f2937;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, background 0.2s ease, color 0.2s ease;
}
.contact-reminders-search__reset:hover:not(:disabled) {
  transform: translateY(-1px);
  border-color: #6366f1;
  background: #eef2ff;
  box-shadow: 0 10px 24px -18px rgba(99, 102, 241, 0.8);
  color: #4338ca;
}
.contact-reminders-search__reset:disabled {
  cursor: not-allowed;
  opacity: 0.42;
}
.contact-reminders-empty {
  padding: 14px;
  color: #475569;
  font-style: italic;
}
.promemoria-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 18px;
  border-radius: 18px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 16px 42px -36px rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(148, 163, 184, 0.18);
}
.promemoria-table thead {
  background: linear-gradient(180deg, #f6f8fc 0%, #edeff5 100%);
  color: #0f172a;
}
.promemoria-table thead th {
  padding: 14px 16px;
  font-size: 0.84rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  text-align: left;
}
.promemoria-table tbody td {
  padding: 13px 16px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.22);
  background: #ffffff;
  color: #1e293b;
  vertical-align: middle;
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
}
.promemoria-table tbody tr:nth-child(odd) td {
  background: #f9fafc;
}
.promemoria-table tbody tr:hover td {
  background: #f0f4ff;
}
.promemoria-table tbody tr:last-child td {
  border-bottom: none;
}
.contact-reminders-table {
  table-layout: fixed;
  min-width: 1040px;
}
.contact-reminders-table thead th {
  padding: 12px 10px;
}
.contact-reminders-table tbody td {
  padding: 10px;
}
.contact-reminders-table .contact-reminders-actions-cell {
  width: 92px;
  min-width: 92px;
}
.contact-reminders-table .contact-reminders-date-cell {
  width: 148px;
}
.contact-reminders-table .contact-reminders-time-cell {
  width: 108px;
}
.contact-reminders-table .contact-reminders-contact-cell {
  width: 280px;
}
.contact-reminders-table .contact-reminders-note-cell {
  width: 236px;
}
.contact-reminders-table .contact-reminders-consultant-cell {
  width: 176px;
}
.promemoria-table th:first-child,
.promemoria-table td:first-child {
  text-align: center;
  width: 150px;
}
.contact-reminders-table th.contact-reminders-actions-cell,
.contact-reminders-table td.contact-reminders-actions-cell {
  width: 92px;
  min-width: 92px;
}
.contact-reminders-table tr.contact-reminder--editing td.contact-reminders-actions-cell {
  width: 92px;
  min-width: 92px;
}
.promemoria-table input[type="date"],
.promemoria-table input[type="time"],
.promemoria-table input[type="text"],
.promemoria-table textarea,
.promemoria-table select {
  width: 100%;
  min-width: 110px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  border-radius: 10px;
  padding: 6px 10px;
  background: #fff;
  font-size: 0.95rem;
  color: #1f2937;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
  text-overflow: clip;
  white-space: nowrap;
}
.promemoria-table input[type="date"]:focus,
.promemoria-table input[type="time"]:focus,
.promemoria-table input[type="text"]:focus,
.promemoria-table textarea:focus,
.promemoria-table select:focus {
  outline: none;
  border-color: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.18);
}

.promemoria-table textarea {
  line-height: 1.35;
  min-height: calc(1.35em * 3 + 14px);
  max-height: calc(1.35em * 3 + 14px);
  overflow-y: auto;
  resize: none;
  white-space: normal;
}
.promemoria-email-cell {
  max-width: 220px;
  width: 220px;
}

.promemoria-email {
  display: block;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
.promemoria-table .contact-reminders-contact,
.promemoria-table .contact-reminders-consultant {
  white-space: normal;
}
.promemoria-table .contact-reminders-contact__meta.promemoria-email {
  max-width: 220px;
  display: block;
  width: 100%;
}
.contact-reminders-table input[type="date"],
.contact-reminders-table input[type="time"],
.contact-reminders-table input[type="text"],
.contact-reminders-table textarea {
  min-width: 0;
  box-sizing: border-box;
}
.contact-reminders-table .contact-reminders-date-cell,
.contact-reminders-table .contact-reminders-time-cell {
  white-space: nowrap;
}
.contact-reminders-table .contact-reminders-date-cell input[type="date"] {
  width: 142px;
  max-width: 142px;
}
.contact-reminders-table .contact-reminders-time-cell input[type="time"] {
  width: 102px;
  max-width: 102px;
}
.contact-reminders-table .contact-reminders-contact,
.contact-reminders-table .contact-reminders-consultant {
  min-width: 0;
  overflow-wrap: anywhere;
}
.contact-reminders-table .contact-reminders-contact__meta.promemoria-email {
  max-width: none;
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
  overflow-wrap: anywhere;
}
.contact-reminders-table .contact-reminder--editing .contact-reminders-actions-cell {
  width: 92px;
  min-width: 92px;
}
.contact-reminders-table .contact-reminder--editing .promemoria-actions {
  grid-template-columns: repeat(2, 28px);
}
.contact-reminder--done {
  opacity: 0.6;
}
.contact-reminders-contact,
.contact-reminders-consultant {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.contact-reminders-contact__name {
  font-weight: 600;
  color: #0f172a;
}
.contact-reminders-contact__meta {
  font-size: 0.85rem;
  color: #475569;
}
.contact-reminders-note {
  min-width: 180px;
  max-width: 260px;
}
.promemoria-block {
  background: #fff;
  border-radius: 18px;
  padding: 26px 28px;
}

.promemoria-block__title {
  margin: 0 0 22px;
  font-size: 1.45rem;
  font-weight: 700;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 8px;
  letter-spacing: 0.01em;
}

.promemoria-block__dot {
  display: inline-flex;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, #4ade80 0%, #16a34a 65%, #15803d 100%);
  box-shadow: 0 0 0 4px rgba(22, 163, 74, 0.16);
  flex-shrink: 0;
}

.promemoria-actions {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.promemoria-actions__btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid rgba(148, 163, 184, 0.45);
  background: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #1f2937;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, background 0.2s ease, color 0.2s ease;
}

.promemoria-actions__btn .material-icons {
  font-size: 20px;
}

.contact-reminders-table .promemoria-actions {
  display: grid;
  grid-template-columns: repeat(2, 28px);
  justify-content: center;
  align-items: center;
  column-gap: 12px;
  row-gap: 8px;
}

.contact-reminders-table .promemoria-actions__btn {
  width: 28px !important;
  min-width: 28px !important;
  max-width: 28px;
  height: 28px !important;
  min-height: 28px !important;
  max-height: 28px;
  flex: 0 0 28px;
  padding: 0 !important;
  box-sizing: border-box;
  line-height: 1;
}

.contact-reminders-table .promemoria-actions__btn .material-icons {
  font-size: 15px;
  line-height: 1;
}

.promemoria-actions__btn:hover {
  transform: translateY(-1px);
  border-color: #6366f1;
  background: #eef2ff;
  box-shadow: 0 10px 24px -18px rgba(99, 102, 241, 0.8);
  color: #4338ca;
}

.promemoria-actions__btn:disabled {
  cursor: not-allowed;
  opacity: 0.42;
  transform: none;
  box-shadow: none;
  background: #f8fafc;
  color: #94a3b8;
}

.promemoria-actions__btn--danger {
  border-color: rgba(239, 68, 68, 0.55);
  color: #b91c1c;
}

.promemoria-actions__btn--danger:hover {
  background: rgba(254, 226, 226, 0.92);
  color: #7f1d1d;
  border-color: rgba(239, 68, 68, 0.8);
}

.promemoria-actions__btn--success {
  border-color: rgba(34, 197, 94, 0.55);
  color: #15803d;
}

.promemoria-actions__btn--success:hover {
  background: rgba(220, 252, 231, 0.95);
  color: #166534;
  border-color: rgba(22, 163, 74, 0.8);
}

@media (max-width: 1200px) {
  .promemoria-email-cell {
    max-width: 180px;
    width: 180px;
  }
  .promemoria-table .contact-reminders-contact__meta.promemoria-email {
    max-width: 180px;
  }
}

@media (max-width: 900px) {
  .promemoria-email-cell {
    max-width: 140px;
    width: 140px;
  }
  .promemoria-table .contact-reminders-contact__meta.promemoria-email {
    max-width: 140px;
  }
}

.my-reminders-filters {
  flex-wrap: wrap;
  align-items: end;
  gap: 14px;
  padding: 16px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 16px;
  background: #f8fafc;
}

.my-reminders-filter-field {
  display: grid;
  flex: 1 1 170px;
  gap: 6px;
  min-width: 150px;
  color: #334155;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.my-reminders-filter-field input,
.my-reminders-filter-field select {
  box-sizing: border-box;
  width: 100%;
  min-height: 44px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  border-radius: 12px;
  background: #ffffff;
  color: #0f172a;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0;
  padding: 8px 12px;
  text-transform: none;
}

.my-reminders-filter-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.my-reminders-filter-actions > button {
  box-sizing: border-box;
  width: 44px;
  min-width: 44px;
  height: 44px;
  margin: 0 !important;
  padding: 0;
}

@media (max-width: 1180px) {
  .promemoria-block--personal {
    padding: 22px;
  }

  .my-reminders-filters {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .my-reminders-status-field,
  .my-reminders-filter-actions {
    grid-column: 1 / -1;
  }

  .my-reminders-table,
  .my-reminders-table tbody {
    display: block;
    width: 100%;
  }

  .my-reminders-table {
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    overflow: visible;
  }

  .my-reminders-table thead {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .my-reminders-table tbody {
    display: grid;
    gap: 16px;
  }

  .my-reminders-table tbody tr {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px 16px;
    padding: 16px;
    border: 1px solid rgba(148, 163, 184, 0.28);
    border-radius: 16px;
    background: #ffffff;
    box-shadow: 0 14px 32px -28px rgba(15, 23, 42, 0.65);
  }

  .my-reminders-table tbody td,
  .my-reminders-table tbody tr:nth-child(odd) td,
  .my-reminders-table tbody tr:hover td {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: auto;
    min-width: 0;
    max-width: none;
    padding: 0;
    border: 0;
    background: transparent;
    overflow: visible;
  }

  .my-reminders-table tbody td::before {
    content: attr(data-label);
    color: #64748b;
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 0.06em;
    line-height: 1.2;
    text-transform: uppercase;
  }

  .my-reminders-table .my-reminders-date-cell,
  .my-reminders-table .my-reminders-time-cell {
    order: 1;
  }

  .my-reminders-table .my-reminders-user-cell {
    grid-column: 1 / -1;
    order: 2;
  }

  .my-reminders-table .my-reminders-type-cell,
  .my-reminders-table .my-reminders-urgency-cell {
    order: 3;
  }

  .my-reminders-table .my-reminders-note-cell {
    grid-column: 1 / -1;
    order: 4;
  }

  .my-reminders-table .my-reminders-status-cell {
    grid-column: 1 / -1;
    order: 5;
  }

  .my-reminders-table .my-reminders-actions-cell {
    grid-column: 1 / -1;
    order: 6;
    align-items: flex-start;
    text-align: left;
  }

  .my-reminders-table input[type="date"],
  .my-reminders-table input[type="time"],
  .my-reminders-table input[type="text"],
  .my-reminders-table select {
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    max-width: none;
    height: 42px;
  }

  .my-reminders-table .promemoria-email {
    white-space: normal;
    overflow-wrap: anywhere;
  }
}

@media (max-width: 680px) {
  .promemoria-block--personal {
    padding: 18px 14px;
    border-radius: 14px;
  }

  .promemoria-block--personal .promemoria-block__title {
    margin-bottom: 16px;
    font-size: 1.2rem;
  }

  .my-reminders-filters {
    grid-template-columns: minmax(0, 1fr);
    padding: 14px;
  }

  .my-reminders-status-field,
  .my-reminders-filter-actions {
    grid-column: auto;
  }

  .my-reminders-filter-actions {
    display: grid;
    grid-template-columns: repeat(4, minmax(44px, 1fr));
  }

  .my-reminders-filter-actions > button {
    width: 100%;
  }

  .my-reminders-table tbody tr {
    grid-template-columns: minmax(0, 1fr);
    padding: 14px;
  }

  .my-reminders-table .my-reminders-user-cell,
  .my-reminders-table .my-reminders-note-cell,
  .my-reminders-table .my-reminders-status-cell,
  .my-reminders-table .my-reminders-actions-cell {
    grid-column: auto;
  }

  .my-reminders-table .promemoria-actions {
    display: grid;
    grid-template-columns: repeat(3, 44px);
    gap: 10px;
  }

  .my-reminders-table .promemoria-actions__btn {
    width: 44px;
    height: 44px;
  }
}

</style>
<style scoped src="../../assets/css/staff-editor-dialog.css"></style>
